import { ArrowLeft, Loader2, Menu, X } from 'lucide-react';
import { useState } from 'react';
import ProfileMenuButton from './ProfileMenuButton';

function Header({
  actionLabel = 'Back to e-Portal',
  accountLabel = 'Account',
  accountAvatar = '',
  showAction = true,
  isMobileMenuOpen = false,
  onAction,
  onLogout,
  onMenuToggle,
  onOpenSettings,
}) {
  const isBackAction = actionLabel === 'Back to e-Portal';
  const MenuIcon = isMobileMenuOpen ? X : Menu;
  const [isActionLoading, setIsActionLoading] = useState(false);

  function handleActionClick() {
    setIsActionLoading(true);
    onAction?.();
  }

  return (
    <header className="flex min-h-[54px] w-full min-w-0 items-center justify-between gap-2 sm:min-h-[62px]">
      <button
        className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[var(--theme-border)] bg-white text-[var(--theme-text-subtle)] shadow-[0_10px_24px_rgba(var(--theme-shadow-rgb),0.09)] transition hover:border-[var(--theme-accent)] hover:bg-[var(--theme-surface-soft)] md:hidden"
        onClick={onMenuToggle}
        type="button"
        aria-label={isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-expanded={isMobileMenuOpen}
      >
        <MenuIcon className="h-4 w-4" aria-hidden="true" />
      </button>
      <div className="ml-auto flex min-w-0 shrink-0 items-center gap-2 md:gap-2.5">
        {showAction ? (
          <button
            className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[var(--theme-border)] bg-white text-[0.86rem] font-semibold text-[var(--theme-text-subtle)] shadow-[0_8px_18px_rgba(var(--theme-shadow-rgb),0.06)] transition hover:border-[var(--theme-accent)] hover:bg-[var(--theme-surface-soft)] disabled:cursor-wait disabled:opacity-75 sm:h-[42px] sm:w-auto sm:gap-2 sm:rounded-[14px] sm:px-4"
            onClick={handleActionClick}
            type="button"
            disabled={isActionLoading}
            aria-label={actionLabel}
            title={actionLabel}
          >
            {isActionLoading ? (
              <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
            ) : isBackAction ? (
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
            ) : null}
            <span className="hidden sm:inline">
              {isActionLoading ? 'Opening...' : actionLabel}
            </span>
          </button>
        ) : null}
        <ProfileMenuButton
          avatar={accountAvatar}
          label={accountLabel}
          onLogout={onLogout}
          onOpenSettings={onOpenSettings}
        />
      </div>
    </header>
  );
}

export default Header;
